import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../images/logoTransparent.png';

const getHeaderOffset = (sectionId) => {
  if (sectionId === 'planner') return 115;
  return 100;
};

const scrollToElement = (sectionId) => {
  const section = document.getElementById(sectionId);

  if (!section) return;

  const sectionPosition =
    section.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: sectionPosition - getHeaderOffset(sectionId),
    behavior: 'smooth',
  });
};

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const scrollTarget = sessionStorage.getItem('scrollTarget');

    if (location.pathname === '/' && scrollTarget) {
      sessionStorage.removeItem('scrollTarget');

      const timer = setTimeout(() => {
        scrollToElement(scrollTarget);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      scrollToElement(sectionId);
    } else {
      sessionStorage.setItem('scrollTarget', sectionId);
      navigate('/');
    }
  };

  return (
    <header className="site-nav">
      <Link to="/" className="brand" aria-label="Office Outing home">
        <img src={logo} alt="Office Outing" />
      </Link>

      <nav>
        <button
          type="button"
          className="nav-link"
          onClick={() => scrollToSection('planner')}
        >
          Find Your Match
        </button>

      <Link to="/browse" className="nav-link">
  Browse All
</Link>

        <Link to="/about" className="nav-link">
          About
        </Link>

        <Link to="/partners" className="nav-link">
  For Partners
</Link>
            
       <Link to="/planning-assistance" className="nav-cta">
  Get Planning Assistance
</Link>

          
      </nav>
    </header>
  );
};

export default Navbar;
